import React, { useEffect, useState } from 'react';
import { Script } from 'gatsby';
import { usePageContext } from '../../hooks/contexts/usePageContext';
import * as styles from './widgetReviews.module.scss';

interface IWidgetReviewsProps {
  codePrestation: string;
  resume?: boolean;
  onlyResume?: boolean;
}

export const WidgetReviews = ({
  codePrestation,
  resume = true,
  onlyResume = false,
}: IWidgetReviewsProps) => {
  const { lang } = usePageContext();
  const elementHtmlId = `widget-reviews-${codePrestation}`;
  const [widgetLoaded, setWidgetLoaded] = useState<boolean>(false);

  useEffect(() => {
    if (typeof window !== 'undefined' && widgetLoaded) {
      const widget = new window.IngenieReviews.Client({
        selector: elementHtmlId,
        url:
          lang === 'fr'
            ? 'https://reservation.tours-tourisme.fr'
            : 'https://booking.tours-tourisme.fr/', // url du site de réservation
        code: codePrestation, // code prestataire ou prestation
        mode: 'slider',
        voirGeneral: resume || onlyResume,
      });
      widget.init();
    }
  }, [codePrestation, resume, onlyResume, elementHtmlId, lang, widgetLoaded]);

  return (
    <>
      <Script
        async
        onLoad={() => setWidgetLoaded(true)}
        src="https://static.ingenie.fr/js/reviews/IngenieReviews.js"
        type="text/javascript"
      />
      <div id={elementHtmlId} className={`${onlyResume ? styles.onlyResume : ''}`} />
    </>
  );
};
